import { jsx as _jsx } from "react/jsx-runtime";
export const FontLoader = () => {
    return (_jsx("link", { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Libre+Franklin|Libre+Franklin:wght@700|Sumana" }));
};
